"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingFilterDropdown = exports.prepareRankingFilterState = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var RankingFilterDropdownBody_1 = require("./RankingFilterDropdownBody");
var react_intl_1 = require("react-intl");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var alignPoints = ["bl tl", "tl bl", "br tr", "tr br"];
var DROPDOWN_ALIGNMENTS = alignPoints.map(function (align) { return ({ align: align, offset: { x: 1, y: 0 } }); });
exports.prepareRankingFilterState = function (filter) {
    var _a = filter.rankingFilter, measure = _a.measure, attributes = _a.attributes, operator = _a.operator, value = _a.value;
    var firstAttribute = attributes && attributes[0];
    var attributesProp = firstAttribute ? { attributes: [firstAttribute] } : {};
    return {
        rankingFilter: tslib_1.__assign({ operator: operator,
            value: value,
            measure: measure }, attributesProp),
    };
};
var RankingFilterDropdownComponent = function (_a) {
    var measureItems = _a.measureItems, attributeItems = _a.attributeItems, filter = _a.filter, onApply = _a.onApply, onCancel = _a.onCancel, anchorEl = _a.anchorEl, onDropDownItemMouseOver = _a.onDropDownItemMouseOver, onDropDownItemMouseOut = _a.onDropDownItemMouseOut, customGranularitySelection = _a.customGranularitySelection, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = react_1.useState(exports.prepareRankingFilterState(filter)), rankingFilter = _b[0], setRankingFilter = _b[1];
    var handleApply = function (rankingFilter) {
        setRankingFilter(rankingFilter);
        onApply(rankingFilter);
    };
    return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { closeOnOutsideClick: true, closeOnParentScroll: true, closeOnMouseDrag: true, alignTo: anchorEl, alignPoints: DROPDOWN_ALIGNMENTS, onClose: onCancel, ignoreClicksOnByClass: [".gd-rf-inner-overlay-dropdown"] },
        react_1.default.createElement(RankingFilterDropdownBody_1.RankingFilterDropdownBody, { measureItems: measureItems, attributeItems: attributeItems, filter: rankingFilter, onApply: handleApply, onCancel: onCancel, onDropDownItemMouseOver: onDropDownItemMouseOver, onDropDownItemMouseOut: onDropDownItemMouseOut, customGranularitySelection: customGranularitySelection, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric })));
};
RankingFilterDropdownComponent.defaultProps = {
    onCancel: noop_1.default,
};
var RankingFilterDropdownWithIntl = react_intl_1.injectIntl(RankingFilterDropdownComponent);
/**
 * @beta
 */
exports.RankingFilterDropdown = function (props) { return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: props.locale },
    react_1.default.createElement(RankingFilterDropdownWithIntl, tslib_1.__assign({}, props)))); };
//# sourceMappingURL=RankingFilterDropdown.js.map